module.exports = __webpack_public_path__ + "img/logo_board.eb41ae26.png";